<h1 mat-dialog-title>Geräte hinzufügen</h1>
<!--<ng-container *ngIf="PS.Has(PS.Permission.GetLedgerImports) | async">-->
<!--    <app-ledger-import-list-card (LedgerImportClick)="onLedgerImportClick($event)" [ShowDocumentButton]="false" [view]="{headline: 'Aus Dokument'}" *ngIf="LedgerImports$ | async as lis" [LedgerImports]="lis"></app-ledger-import-list-card>-->
<!--</ng-container>-->
<app-select-resource mat-dialog-content #selectResourceComponent [ComponentData]="Dialogdata" [ShowHeadline]="false"></app-select-resource>
<mat-dialog-actions class="button-wrapper">
    <button app-button Inverted Color="cancel" [mat-dialog-close]="null">Abbrechen</button>
    <button app-button (click)="selectResourceComponent.Save()">Speichern</button>
</mat-dialog-actions>
